/**
 * Three Part Counter - Dedicated counter for three-part-section
 * This is a separate implementation to avoid conflicts with silo-counter.js
 */

// Function to animate counting up
function animateThreePartCounter(element, targetValue, duration = 2000) {
  // Parse the target value into numeric component and suffix
  const valueText = targetValue.trim();
  let numericValue = '';
  let prefix = '';
  let suffix = '';
  
  // Extract numeric value and any prefix/suffix
  if (valueText.startsWith('$') || valueText.includes('$')) {
    if (valueText.startsWith('$')) {
      prefix = '$';
      numericValue = valueText.substring(1).replace(/[^0-9.]/g, '');
    } else {
      numericValue = valueText.replace(/[^0-9.]/g, '');
      suffix = '$';
    }
  } else if (valueText.endsWith('%')) {
    numericValue = valueText.substring(0, valueText.length - 1).replace(/[^0-9.]/g, '');
    suffix = '%';
  } else if (valueText.endsWith('x')) {
    numericValue = valueText.substring(0, valueText.length - 1).replace(/[^0-9.]/g, '');
    suffix = 'x';
  } else if (valueText.toLowerCase().includes('lbs')) {
    numericValue = valueText.replace(/[^0-9.]/g, '');
    suffix = 'Lbs';
  } else {
    // For any other format, just extract the numbers
    numericValue = valueText.replace(/[^0-9.]/g, '');
    // Check if there's any non-numeric suffix
    const nonNumericSuffix = valueText.replace(/[0-9,.]/g, '').trim();
    if (nonNumericSuffix) {
      suffix = nonNumericSuffix;
    }
  }
  
  // Handle commas in the number
  numericValue = numericValue.replace(/,/g, '');
  
  // Convert to a number for animation
  const targetNum = parseFloat(numericValue);
  
  // Start from zero
  let startNum = 0;
  let startTime = null;
  
  // Format function for large numbers
  function formatNumber(num) {
    return new Intl.NumberFormat().format(Math.round(num));
  }
  
  // Set initial value to 0 with prefix/suffix
  element.textContent = `${prefix}0${suffix}`;
  
  // Animation function
  function updateCounter(timestamp) {
    if (!startTime) startTime = timestamp;
    
    const progress = Math.min((timestamp - startTime) / duration, 1);
    const currentNum = progress * (targetNum - startNum) + startNum;
    
    // Format the number with commas for thousands
    const formattedNum = formatNumber(currentNum);
    
    // Update the element text with the current number and preserve prefix/suffix
    element.textContent = `${prefix}${formattedNum}${suffix}`;
    
    if (progress < 1) {
      // Continue the animation
      requestAnimationFrame(updateCounter);
    } else {
      // Ensure final value is exactly the target text with proper formatting
      // We use the original value to preserve original formatting
      element.textContent = valueText;
    }
  }
  
  // Start the animation
  requestAnimationFrame(updateCounter);
}

// Initialize counters when they become visible
function initializeThreePartCounters(containerSelector) {
  const statsSection = typeof containerSelector === 'string' 
    ? document.querySelector(containerSelector)
    : containerSelector;
    
  if (!statsSection) {
    console.error('Three-part stats container not found:', containerSelector);
    return;
  }
  
  // Get all statistic values in this section
  const statElements = statsSection.querySelectorAll('.statistic-value');
  
  if (statElements.length === 0) {
    console.warn('No statistic elements found in three-part container:', containerSelector);
    return;
  }
  
  
  // Reset all statistic values to 0 immediately
  statElements.forEach(element => {
    const targetValue = element.getAttribute('data-value');
    if (!targetValue) {
      console.warn('Statistic element missing data-value attribute:', element);
      return;
    }
    
    // Set to zero but maintain prefix/suffix format
    const valueText = targetValue.trim();
    let prefix = '';
    let suffix = '';
    
    if (valueText.startsWith('$')) {
      prefix = '$';
    } else if (valueText.includes('$')) {
      suffix = '$';
    } else if (valueText.endsWith('%')) {
      suffix = '%';
    } else if (valueText.endsWith('x')) {
      suffix = 'x';
    } else if (valueText.toLowerCase().includes('lbs')) {
      suffix = 'Lbs';
    }
    
    element.textContent = `${prefix}0${suffix}`;
  });
  
  // Use Intersection Observer to detect when statistics are visible
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        
        // Animate each statistic with a slight delay between them
        statElements.forEach((element, index) => {
          const originalValue = element.getAttribute('data-value');
          setTimeout(() => {
            animateThreePartCounter(element, originalValue);
          }, index * 200); // 200ms delay between each counter start
        });
        
        // Unobserve after triggering the animation
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.25 }); // Trigger when at least 25% of the section is visible
  
  // Begin observing
  observer.observe(statsSection);
}

// Export the functions using a different namespace
window.ThreePartCounter = {
  animateCounter: animateThreePartCounter,
  initializeCounters: initializeThreePartCounters
}; 